import styles from "../RefundPage.module.scss";

/**
 * Блок с информацией о товарах, не подлежащих возврату
 * @constructor
 */
export const NotRefundProduct = () => {
    return (
        <div className={styles.mb}>
            <h4>Товары надлежащего качества, не подлежащих обмену или возврату:</h4>
            <ul>
                <li> масло моторное, промывочное, трансмиссионное, специальное;</li>
                <li> все тормозные, охлаждающие, стеклоомывающие жидкости;</li>
                <li> смазки, присадки, герметики, клеи, краски, лаки, грунтовки;</li>
                <li> товары по уходу за салоном, кузовом, стеклом;</li>
                <li> товар не подошёл из-за изменённой конструкции автомобиля, при этом подбор был правильный;</li>
                <li> товар имеет следы установки.</li>
            </ul>
            * Полный перечень товаров надлежащего качества, не подлежащих возврату или обмену на аналогичный товар других размера,
            формы, габарита, фасона, расцветки или комплектации содержится в <a className="primary-color" href="https://www.consultant.ru/document/cons_doc_LAW_373622/a7e95958f6d9c791e728172bd17d5df3b1152118/" target="_blank">«Перечень непродовольственных товаров надлежащего качества, не подлежащих обмену»</a>
            (утверждён постановлением Правительства Российской Федерации от 31 декабря 2020 г. №2463).
        </div>
    );
};
